// MpfAttachmentList.props.ts
// Not in NHS DS — built on their link and type-scale foundations. The download
// counterpart to MpfFilesSummary, which is File[]-only and cannot render remote items.
import type { HeadingLevel } from '../MpfInput/MpfInputBaseProps';

export interface MpfAttachmentItem {
  fileName: string | null;
  href: string;
}

export interface MpfAttachmentListProps {
  items: MpfAttachmentItem[];
  heading?: string;
  headingLevel?: HeadingLevel;
  fallbackFileName?: string;
  target?: string;
}

export const mpfAttachmentListDefaults = {
  headingLevel: 3,
  fallbackFileName: 'Download attachment',
  target: '_blank',
} satisfies Partial<MpfAttachmentListProps>;
